import Container from "../ui/Container";

const footerGroups = [
  {
    title: "Products",
    links: [{ label: "GradeVIT", href: "https://gradevit.technie.in" }, { label: "All Products", href: "/products" }]
  },
  {
    title: "Company",
    links: [{ label: "Blog", href: "#blog" }, { label: "About", href: "#about" }, { label: "Contact", href: "mailto:support@technie.in" }]
  },
  {
    title: "Social",
    links: [
      { label: "GitHub", href: "https://github.com/technie-in" },
      { label: "LinkedIn", href: "https://www.linkedin.com/company/technie-in" }
    ]
  }
];

function Footer({ onNavigate }) {
  const handleClick = (event, href) => {
    if (href.startsWith("/") || href.startsWith("#")) {
      event.preventDefault();
      onNavigate(href);
    }
  };

  return (
    <footer className="border-t border-border/80 py-10">
      <Container>
        <div className="grid gap-8 sm:grid-cols-[1.2fr_2fr]">
          <div>
            <p className="text-sm font-semibold tracking-[0.16em] text-primary">TECHNIE</p>
            <p className="mt-3 max-w-xs text-sm leading-6 text-secondary">
              Building practical digital products under one focused studio.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h2 className="text-sm font-medium text-primary">{group.title}</h2>
                <ul className="mt-3 space-y-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(event) => handleClick(event, link.href)}
                        className="text-sm text-secondary transition-all duration-200 ease-in-out hover:text-accent focus-visible:shadow-focus-ring"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-border/70 pt-5 text-sm text-muted sm:flex-row sm:items-center sm:justify-between">
          <p>Built by Technie</p>
          <p>Independent technology studio</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
